import * as React from 'react';
import cn from 'clsx';
import { UIText2 } from '@cian/ui-kit/typography';
import { INFRASTRUCTURE_MAP_ICON_MAP } from '../../../../constants/infrastructure';
import * as styles from './styles.css';

export interface IMapInfrastructureBalloonWithRouteProps {
  description?: string;
  routeButtonId: string;
  timeWalk?: string;
  title: string;
  type: string;
  iconBackgroundColor: 'blue' | 'green';
  dateText?: string;
}

export function MapInfrastructureBalloonWithRoute(props: IMapInfrastructureBalloonWithRouteProps) {
  const { description, routeButtonId, timeWalk, title, type, iconBackgroundColor, dateText } = props;
  const Icon = INFRASTRUCTURE_MAP_ICON_MAP.get(type);

  if (!Icon) {
    return null;
  }

  return (
    <div className={styles['balloon']}>
      <div className={cn(styles['icon'], styles[iconBackgroundColor])}>
        <Icon color={'white_100'} />
      </div>
      <div>
        <UIText2>{title}</UIText2>
        {dateText && <UIText2 color={'gray60_100'}>{dateText}</UIText2>}
        {description && <UIText2 color={'gray60_100'}>{description}</UIText2>}
        {timeWalk && <UIText2 color={'gray60_100'}>{timeWalk}</UIText2>}
        <div className={styles['route']}>
          <button id={routeButtonId} className={styles['route-button']} type="button">
            Построить маршрут
          </button>
        </div>
      </div>
    </div>
  );
}
